

const UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

const SESSION_STORAGE_KEY = "utm_params";

export function captureUTMParams(searchParams) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    const utmParams = {};
    let hasUTM = false;

    UTM_PARAMS.forEach((param) => {
      const value = searchParams.get(param);
      if (value) {
        utmParams[param] = value;
        hasUTM = true;
      }
    });

    if (hasUTM) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(utmParams));
    }
  } catch (error) {
    console.error("Error capturing UTM params:", error);
  }
}


//When user submits the form, we need to get the UTM params from the session storage
export function getUTMParams() {
  try {
    const storedParams = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (storedParams){
      return JSON.parse(storedParams);
    }
    return null;
  } catch (error){
    console.error("Error getting UTM params:",error);
    return null;
  }
}